import React, { useState } from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import classNames from "classnames";

const SwPhoneInput = ({
  value,        // phone number
  onChange,     // set phone number
  placeholder = "Enter phone number", // placeholder
  disabled = false, // true or false
  error = false,          // boolean for styling
  errorMsg = "",          // 👈 actual message to show
  className = "",         // class name
  containerClass = "",    // container class name
  defaultCountry = "in",  // default country
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div
      className={classNames(
        "SwPhoneInput",
        isFocused && "SwPhoneInput--focused",
        error && "SwPhoneInput--error",
        containerClass
      )}
    >
      <PhoneInput
        defaultCountry={defaultCountry}
        value={value ?? ''}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={classNames("sw-phone-input", className)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />

      {error && errorMsg && (
        <div className="sw-form-error">
          {errorMsg}
        </div>
      )}
    </div>
  );
};

export default SwPhoneInput;
